import initialState from './initialState';
import actionType from './actionTypes';

const notificationItemReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.SHOW_NOTIFICATION: {
            const { message, icon, id } = action.payload;
            return {
                message,
                icon,
                level: 'success',
                id,
            };
        }
        default:
            return state;
    }
};

export default notificationItemReducer;
